import { render, staticRenderFns } from "./StudentCourseTrend.vue?vue&type=template&id=126653cb"
import script from "./StudentCourseTrend.vue?vue&type=script&lang=js"
export * from "./StudentCourseTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports